<div #scrollContainer class="scroll_container">
    <div class="estimation-header">
        <div class="vertical-center header-content">
            @if (currentPhase === 1) {
            <a matTooltip="{{ variables.goBack}}" matTooltipPosition="below" aria-label="{{ variables.goBack}}"
                (click)="goToDashboard()">
                <mat-icon class="header-icon-img">arrow_circle_left</mat-icon>

            </a>
            }
            <h4 class="estimation-title" [ngClass]="{'title-no-margin': currentPhase === 1 }">
                {{ isUpdate ? (estimateName ? variables.estimate + ' - ' + estimateName : variables.estimate) :
                (estimateName ? variables.newEstimate + ' - ' + estimateName : variables.newEstimate) }}
            </h4>
        </div>
        <div class="main-phase-stepper">
            <div [class.phase-active]="currentPhase === 1" class="phase-step">
                <div class="phase-number">
                    <mat-icon class="icon-style">integration_instructions</mat-icon>
                </div>
                <span class="phase-label">{{variables.estimate}}</span>
            </div>
            <div class="phase-divider"></div>
            <div [class.phase-active]="currentPhase === 2" class="phase-step">
                <div class="phase-number">
                    <mat-icon class="icon-style">view_list</mat-icon>
                </div>
                <span class="phase-label">{{variables.subTasks}}</span>
            </div>
        </div>
    </div>

    <!-- Phase 1: Estimation Form -->
    @if (currentPhase === 1) {
    <app-custom-stepper [estimate]="estimate" [subTasks]="subTasks" (scrollRequest)="handleScroll($event)"
        (goToActivitiesEvent)="goToActivities($event)" (estimateNameChange)="onEstimateNameChange($event)"
        (isUpdateChange)="onIsUpdateChange($event)">
    </app-custom-stepper>
    }

    <!-- Phase 2: Activities/Subtasks -->
    @if (currentPhase === 2) {
    <app-activity [atividades]="subTasks" [estimate]="estimate" [technology]="technology"
        [originalProject]="originalProject" [isUpdate]="isUpdate" [idEstimate]="idEstimate" 
        [modifiedSubTasks]="modifiedSubTasks" [subTasksAiWarning]="subTasksAiWarning"
        (estimateEvent)="backToEstimativa($event)" (atividadesEvent)="updateSubTasks($event)">
    </app-activity>
    }
</div>